import { Directive, HostBinding, Inject, OnDestroy, OnInit } from '@angular/core';
import { AppWindow } from '../AppWindow';

@Directive({
  selector: '[appHeaderShadow]',
})
export class HeaderShadowDirective implements OnInit, OnDestroy {
  //assigning default value as false,instead of using null or undefined to keep the @HostBinding property as boolean type.
  @HostBinding('class.shadow') shadow: boolean = false;

  constructor(@Inject('window') private window: AppWindow) {}

  ngOnInit(): void {
    this.window.addEventListener('scroll', this._checkScroll);
  }

  ngOnDestroy(): void {
    this.window.removeEventListener('scroll', this._checkScroll);
  }

  private _checkScroll = (): void => {
    this.shadow = this.window.pageYOffset > 20;
  };
}
